var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teamInfo" }, [
    _c(
      "div",
      { staticClass: "search_container" },
      [
        _c(
          "el-button",
          {
            attrs: { size: "mini", type: "primary" },
            on: {
              click: function () {
                _vm.$emit("changeActive", 1)
              },
            },
          },
          [_vm._v("返回")]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "comPractice_container" }, [
      _c("div", { staticClass: "signUp_info_main" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("h2", [_vm._v(_vm._s(_vm.groupName))]),
            _vm.teamList && _vm.teamList.length > 0
              ? _vm._l(_vm.studentFormList, function (item, i) {
                  return _c("el-form", { key: i }, [
                    _c("div", { staticClass: "formBox" }, [
                      _c(
                        "div",
                        { staticClass: "item only_one" },
                        _vm._l(item.teamName, function (ele, n) {
                          return _c(
                            "el-form-item",
                            {
                              key: "teamName" + n,
                              attrs: {
                                prop:
                                  "teamName[" +
                                  n +
                                  "]." +
                                  [ele.configField] +
                                  "_1",
                                label: ele.configLabel + ++i + "：",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(ele[ele.configField + "_1"]) + " "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c("div", { staticClass: "label" }, [
                        _c("p", [
                          _vm._v(
                            " 领队信息" +
                              _vm._s(_vm.ismaxLeaderCount != 0 ? 1 : "") +
                              " "
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "commonFlex" },
                        _vm._l(item.leaderList, function (val, n) {
                          return _c(
                            "div",
                            { key: "leader" + n, staticClass: "leaderList" },
                            [
                              _c(
                                "div",
                                { staticClass: "item four" },
                                [
                                  val.configFieldType == 0
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: val.configLabel + "：",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                val[val.configField + "_1"]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  val.configFieldType == 1
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: val.configLabel + "：",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              model: {
                                                value:
                                                  val[val.configField + "_1"],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    val,
                                                    val.configField + "_1",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "val[val.configField + '_1']",
                                              },
                                            },
                                            _vm._l(
                                              JSON.parse(val.configList),
                                              function (vs, i) {
                                                return _c("el-option", {
                                                  key: i,
                                                  attrs: {
                                                    label: vs.v,
                                                    value: vs.id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm.ismaxLeaderCount != 0
                        ? _c(
                            "div",
                            _vm._l(_vm.ismaxLeaderCount, function (n, i) {
                              return _c("div", { key: n }, [
                                _c("div", { staticClass: "label" }, [
                                  _c("p", [
                                    _vm._v(" 领队信息 " + _vm._s(++n) + " "),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "commonFlex" },
                                  _vm._l(
                                    item["leaderList_" + i],
                                    function (val, n) {
                                      return _c(
                                        "div",
                                        {
                                          key: "student" + n,
                                          staticClass: "leaderList",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item four" },
                                            [
                                              val.configFieldType == 0
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label:
                                                          val.configLabel +
                                                          "：",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            val[
                                                              val.configField +
                                                                "_1"
                                                            ]
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              val.configFieldType == 1
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label:
                                                          val.configLabel +
                                                          "：",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          model: {
                                                            value:
                                                              val[
                                                                val.configField +
                                                                  "_1"
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                val,
                                                                val.configField +
                                                                  "_1",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "val[val.configField + '_1']",
                                                          },
                                                        },
                                                        _vm._l(
                                                          JSON.parse(
                                                            val.configList
                                                          ),
                                                          function (vs, i) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: i,
                                                                attrs: {
                                                                  label: vs.v,
                                                                  value: vs.id,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "label" }, [
                        _c("p", [
                          _vm._v(
                            " 选手信息" +
                              _vm._s(_vm.isNumber != 0 ? 1 : "") +
                              " "
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "commonFlex" },
                        _vm._l(item.studentList, function (val, n) {
                          return _c(
                            "div",
                            { key: "student" + n, staticClass: "studentList" },
                            [
                              _c(
                                "div",
                                { staticClass: "item four" },
                                [
                                  val.configFieldType == 0
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: val.configLabel + "：",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                val[val.configField + "_1"]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  val.configFieldType == 1
                                    ? _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: val.configLabel + "：",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              model: {
                                                value:
                                                  val[val.configField + "_1"],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    val,
                                                    val.configField + "_1",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "val[val.configField + '_1']",
                                              },
                                            },
                                            _vm._l(
                                              JSON.parse(val.configList),
                                              function (vs, i) {
                                                return _c("el-option", {
                                                  key: i,
                                                  attrs: {
                                                    label: vs.v,
                                                    value: vs.id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm.isNumber != 0
                        ? _c(
                            "div",
                            _vm._l(_vm.isNumber, function (n, i) {
                              return _c("div", { key: n }, [
                                _c("div", { staticClass: "label" }, [
                                  _c("p", [
                                    _vm._v(" 选手信息 " + _vm._s(++n) + " "),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "commonFlex" },
                                  _vm._l(
                                    item["studentList_" + i],
                                    function (val, n) {
                                      return _c(
                                        "div",
                                        {
                                          key: "student" + n,
                                          staticClass: "studentList",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item four" },
                                            [
                                              val.configFieldType == 0
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label:
                                                          val.configLabel +
                                                          "：",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            val[
                                                              val.configField +
                                                                "_1"
                                                            ]
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              val.configFieldType == 1
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label:
                                                          val.configLabel +
                                                          "：",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          model: {
                                                            value:
                                                              val[
                                                                val.configField +
                                                                  "_1"
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                val,
                                                                val.configField +
                                                                  "_1",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "val[val.configField + '_1']",
                                                          },
                                                        },
                                                        _vm._l(
                                                          JSON.parse(
                                                            val.configList
                                                          ),
                                                          function (vs, i) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: i,
                                                                attrs: {
                                                                  label: vs.v,
                                                                  value: vs.id,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                      _c("div", [
                        _c("div", { staticClass: "label" }, [
                          _c("p", [
                            _vm._v(
                              " 指导教师信息 " +
                                _vm._s(_vm.ismaxTeacherCount != 0 ? 1 : "") +
                                " "
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "commonFlex" },
                          _vm._l(item.teacherList, function (val, n) {
                            return _c(
                              "div",
                              {
                                key: "teacher" + n,
                                staticClass: "teacherList",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "item four" },
                                  [
                                    val.configFieldType == 0
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: val.configLabel + "：",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  val[val.configField + "_1"]
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    val.configFieldType == 1
                                      ? _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: val.configLabel + "：",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                model: {
                                                  value:
                                                    val[val.configField + "_1"],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      val,
                                                      val.configField + "_1",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "val[val.configField + '_1']",
                                                },
                                              },
                                              _vm._l(
                                                JSON.parse(val.configList),
                                                function (vs, i) {
                                                  return _c("el-option", {
                                                    key: i,
                                                    attrs: {
                                                      label: vs.v,
                                                      value: vs.id,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm.ismaxTeacherCount != 0
                        ? _c(
                            "div",
                            _vm._l(_vm.ismaxTeacherCount, function (n, i) {
                              return _c("div", { key: n }, [
                                _c("div", { staticClass: "label" }, [
                                  _c("p", [
                                    _vm._v(
                                      " 指导教师信息 " + _vm._s(++n) + " "
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "commonFlex" },
                                  _vm._l(
                                    item["teacherList_" + i],
                                    function (val, n) {
                                      return _c(
                                        "div",
                                        {
                                          key: "teacherList" + n,
                                          staticClass: "teacherList",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item four" },
                                            [
                                              val.configFieldType == 0
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label:
                                                          val.configLabel +
                                                          "：",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            val[
                                                              val.configField +
                                                                "_1"
                                                            ]
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              val.configFieldType == 1
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label:
                                                          val.configLabel +
                                                          "：",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          model: {
                                                            value:
                                                              val[
                                                                val.configField +
                                                                  "_1"
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                val,
                                                                val.configField +
                                                                  "_1",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "val[val.configField + '_1']",
                                                          },
                                                        },
                                                        _vm._l(
                                                          JSON.parse(
                                                            val.configList
                                                          ),
                                                          function (vs, i) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: i,
                                                                attrs: {
                                                                  label: vs.v,
                                                                  value: vs.id,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                    ]),
                  ])
                })
              : [
                  _c("div", { staticClass: "no_content" }, [
                    _vm._v(" 暂无" + _vm._s(_vm.groupName) + "报名信息 "),
                  ]),
                ],
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "报名审核",
                  "close-on-click-modal": false,
                  "close-on-press-escape": false,
                  visible: _vm.dialogVisible,
                  width: "30%",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogVisible = $event
                  },
                },
              },
              [
                _c("h2", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("审核是否通过？"),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.audit_pass(1)
                          },
                        },
                      },
                      [_vm._v("通过")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.audit_pass(0)
                          },
                        },
                      },
                      [_vm._v("未通过")]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "提示",
                  "close-on-click-modal": false,
                  "close-on-press-escape": false,
                  visible: _vm.dialogVisible_audit_nopass,
                  width: "30%",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogVisible_audit_nopass = $event
                  },
                },
              },
              [
                _c("span", [_vm._v("请输入审核未通过原因：")]),
                _c(
                  "p",
                  { staticStyle: { "margin-top": "10px" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "请输入内容",
                      },
                      model: {
                        value: _vm.cause,
                        callback: function ($$v) {
                          _vm.cause = $$v
                        },
                        expression: "cause",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.commonReviewReject(0)
                          },
                        },
                      },
                      [_vm._v("确认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: {
                          click: function ($event) {
                            ;(_vm.dialogVisible = true),
                              (_vm.dialogVisible_audit_nopass = false)
                          },
                        },
                      },
                      [_vm._v("上一步")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "right" },
          [
            _vm.deptProofList
              ? [
                  _vm.deptProofList && _vm.deptProofList.length > 0
                    ? _vm._l(_vm.deptProofList, function (item, i) {
                        return _c(
                          "div",
                          { key: i, staticClass: "img_box" },
                          [
                            _c("el-image", {
                              attrs: {
                                src: item.attachUrl,
                                "preview-src-list": [item.attachUrl],
                              },
                            }),
                            _c(
                              "i",
                              {
                                staticClass: "imageName",
                                attrs: { title: item.attachName },
                              },
                              [_vm._v(_vm._s(item.attachName))]
                            ),
                          ],
                          1
                        )
                      })
                    : [
                        _c("div", { staticClass: "no_content" }, [
                          _vm._v(" 暂无审核资料 "),
                        ]),
                      ],
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "operation" },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: _vm.teamInfoData.isDisabled ? "default" : "primary",
                disabled: _vm.teamInfoData.isDisabled ? true : false,
              },
              on: {
                click: function () {
                  _vm.dialogVisible = true
                },
              },
            },
            [_vm._v("审核")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.goback } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }